import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { FormGroup, FormControl } from '@angular/forms';
import { DataModelComponent } from '../../models/data.model.component';
import { ChatPersons, IChatPersons, ChatMessages, IChatMessages } from '../../models/ChatMessages.model';


@Component({
  selector: 'chat-messages',
  templateUrl: './chat-messages.component.html',
  styleUrls: ['./chat-messages.component.css']
})
export class ChatMessagesComponent implements OnInit {
  data=null;
  mouseCount=0;
  selectedItem = null;
  selected = false;
  personsVisible:boolean=true;
  personAdding:boolean=false;
  personNome:string;
  mostrarNomes:boolean=true;
  me:string="nc@construir.com.br";
  to:string="";
  history = [];

  historyClassTo: ChatMessages;
  historyClassFrom: ChatMessages;
  historyReadOnlyClass:ChatMessages;
  
  persons = [];
  personsClass : ChatPersons;
  content: string = '';
  form: FormGroup;
  formPersonAdd: FormGroup;
  constructor(private db:AngularFirestore) {
    this.form = new FormGroup({
      content: new FormControl(),
    });
    this.formPersonAdd = new FormGroup(
      {
        personNome: new FormControl()
      }
    )
  }

  ngOnInit() {

    this.historyReadOnlyClass = new ChatMessages(this.db);

    this.personsClass = new ChatPersons(this.db);
    this.personsClass.changedEvent.subscribe( r=>{
      this.persons = r;
    });

    this.historyClassFrom = new ChatMessages(this.db);
    this.historyClassFrom.changedEvent.subscribe(
      r=>{ 
        console.log(r);
        this.history.push(...r)  ; 
    });


    this.historyClassTo = new ChatMessages(this.db);
    this.historyClassTo.changedEvent.subscribe(
      r=>{ 
        console.log(r);
        this.history.push(...r); 
        }
    );

    this.loadPersons(this.me);
  }

  loadPersons( me:string ){
    this.me = me;
    this.personsClass.snapshot(
       r => r.where('owner','==',this.me)
    );
}

  loadMessages(){
    this.history.length = 0;
    console.log(this.to);
    this.historyClassTo.snapshot(
       r => r.where('to','==',this.me)
             .where('from','==',this.to)
    );
    this.historyClassFrom.snapshot(
      r => r.where('to','==',this.to)
            .where('from','==',this.me)
    );
  }

  sendMessage(texto) {
    let x: IChatMessages = {
      owner: this.me,
      content: texto,
      type: "message",
      timestamp: new Date(),
      from: this.me,
      to: this.to,
      refer: 0,
      read: false,
    };
    this.historyClassFrom.add(x);
    this.content = '';
  }

  carimbaHora(dh){
    return 'hoje';
  }

  onClickAddPerson(){
    console.log('addPerson');
    this.personAdding = true;
  }
  onClickPersons(item){
    this.personsVisible = false;
    this.to = item.name;
    this.loadMessages();
  } 
  onClickBack(){
    this.personsVisible = true;
  }
  addPerson()
  {
    let y : IChatPersons = {
      owner : this.me,
      name : this.personNome,
      sigla: this.personNome[0]+this.personNome[1]
    };
    this.personsClass.add(y);
  }

  mouseMoveInit(it){
    console.log('init');
    this.mouseCount = 0;
    this.selected = false;
    this.data = it.timestamp;
  }
  mouseMove(it){
    console.log('mousemove');
    this.mouseCount ++;
    if (this.mouseCount>20){
      this.selectedItem = it;
      this.selected = true;
    }
  }
  goToday(){
    this.historyClassTo.snapshot(
      r => r.where('to','==',this.me)
            .where('from','==',this.to)
   );
   this.historyClassFrom.snapshot(
     r => r.where('to','==',this.to)
           .where('from','==',this.me)
   );
   
  }

  doClick(item){
    this.data = item.timestamp;
  }
}
